import { AnyPlainObject } from "../../common/misc";
import { ServiceCaller } from "../base";

export type DummyServiceResponses = {
  callService: {
    [service: string]: {
      resFn: (req: any) => any;
    };
  };
  callSpotService: { cmd: string; req: any; res: any }[];
  callCustomActionService: { service: string; req: any; res: any }[];
};

const DEFAULT_DUMMY_RESPONSES: DummyServiceResponses = {
  callCustomActionService: [],
  callService: {},
  callSpotService: [],
};

export class DummyServiceCaller extends ServiceCaller {
  dummyResponses: DummyServiceResponses;
  constructor(dummyResponses: DummyServiceResponses = DEFAULT_DUMMY_RESPONSES) {
    super();
    this.dummyResponses = dummyResponses;
  }

  callService = <ReqType, ResType>(
    service: string,
    data: ReqType,
    options?: { serviceType?: string }
  ): Promise<ResType> => {
    console.log(
      "DummyServiceCaller's callService called with service:",
      service,
      "and:",
      data,
      "serviceType:",
      options?.serviceType
    );
    return new Promise((resolve, reject) => {
      try {
        const res = this.dummyResponses.callService[service].resFn(
          data
        ) as ResType;
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  };

  callSpotService = <ReqType, ResType>(
    cmd: string,
    data: ReqType
  ): Promise<ResType> => {
    console.log(
      "DummyServiceCaller's callSpotService called with cmd:",
      cmd,
      "and data:",
      data
    );
    return new Promise((resolve) => resolve({} as ResType));
  };

  callCustomActionService = <ReqType extends AnyPlainObject, ResType>(
    service: string,
    args: ReqType
  ): Promise<ResType> => {
    console.log(
      "DummyServiceCaller's callSpotService called with service:",
      service,
      "and args:",
      args
    );
    return new Promise((resolve) => resolve({} as ResType));
  };
}
